import React, { Fragment } from 'react';

import * as Actions from 'depreciations/components/list/actions';

const DepreciationsActions = ({ permissions, depreciation, company, subcompany, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.depreciations.toggle'] && (
        <Actions.Toggle depreciation={depreciation} handleClick={handleToggle} />
      )}
      {permissions['acl.depreciations.update'] && (
        <Actions.Edit depreciation={depreciation} company={company} subcompany={subcompany} />
      )}
    </Fragment>
  );
};

export default DepreciationsActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/DepreciationsActions.js